module.exports = __webpack_public_path__ + "img/ug.c94bc7a8.svg";